import React from 'react';
import { STORE_DETAILS, ASSETS } from '@/config/store';
import { ImageWithFallback } from '@/components/ui';

const navLinks = [
  { href: '#about', label: 'About' },
  { href: '#contact', label: 'Visit' },
];

export function Navbar() {
  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-white/90 border-b border-ink/8 backdrop-blur-sm pt-[env(safe-area-inset-top)]"
      aria-label="Main navigation"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="h-14 sm:h-[4.5rem] flex items-center justify-between gap-4">
          <a
            href="/"
            className="flex items-center gap-2.5 sm:gap-3 group min-w-0 touch-manipulation"
            aria-label="Bagbazar Provision Stores - Home"
          >
            <div className="w-9 h-9 sm:w-11 sm:h-11 bg-white rounded-full flex items-center justify-center p-1 overflow-hidden shrink-0 ring-1 ring-ink/10">
              <ImageWithFallback
                src={ASSETS.logoBlue}
                alt={`${STORE_DETAILS.name} Logo`}
                className="w-full h-full object-contain scale-110"
                width={1024}
                height={1024}
                fallbackContent={
                  <div className="w-full h-full rounded-full flex items-center justify-center bg-brand">
                    <span className="text-white text-[8px] font-bold text-center leading-tight px-0.5">
                      BAGBAZAR
                    </span>
                  </div>
                }
              />
            </div>
            <div className="min-w-0">
              <span className="font-display text-base sm:text-lg font-bold text-ink tracking-tight block leading-tight truncate">
                Bagbazar
              </span>
              <span className="text-[9px] sm:text-[10px] text-muted font-medium uppercase tracking-[0.14em]">
                Provision Stores
              </span>
            </div>
          </a>

          <div className="flex items-center gap-0.5 sm:gap-1">
            {navLinks.map(({ href, label }) => (
              <a
                key={href}
                href={href}
                className="min-h-11 inline-flex items-center px-3 sm:px-4 py-2 text-sm font-medium text-muted hover:text-brand transition-colors cursor-pointer touch-manipulation focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 rounded-md"
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
